import React from 'react';
import ProfileMenu from "./ProfileMenu";
import {IconButton, Typography} from "@material-tailwind/react";
import PersianNumberFormat from "../../helper/PersianNumberFormat";
import {BsList} from "react-icons/bs";
import {NotificationsMenu} from "./NotificationsMenu";
import {RolesMenu} from "./RolesMenu";


const Header = ({className, userInfo, isOpen, setIsOpen, onClick}) => {
  const {name, phone} = userInfo;


  return <header
    className={`${className} app-header z-10 flex w-full justify-between border-b px-4 text-app-text transition-colors`}
  >
    <div className="flex flex-row">
      {!isOpen ?
        <IconButton variant="text" onClick={() => {
          setIsOpen(true)
        }} className="text-4xl font-bold text-app-text-muted hover:bg-app-muted">
          <BsList/>
        </IconButton>
        : null
      }
      <div>

        <RolesMenu onClick={onClick}/>

      </div>

      <Typography variant="h5" className="pr-2 text-app-text">
        <Typography className="text-app-text">
          سلام {name}
        </Typography>
        <Typography variant="small" className="text-app-text-muted">
          {PersianNumberFormat(phone)}
        </Typography>
      </Typography>
    </div>
    <div className="flex flex-row items-center gap-x-2 sm:gap-x-4">
      <NotificationsMenu onClick={onClick}/>
      <ProfileMenu className="pl-2" onClick={onClick}/>
    </div>
  </header>;
};

export default Header;
